// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","headerRight":"Header_headerRight__CSwO3","mobileButton":"Header_mobileButton__potAJ","webButton":"Header_webButton__H+6-a"};